import * as React from "react";
const FundingCoverageIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.558 14.02h5.833L22.189 8.6a1.459 1.459 0 0 0-1.424-1.142h-3.937a.73.73 0 0 0-.712.888l1.442 5.675Zm7.295 20.688v1.094c0 .605-.489 1.094-1.094 1.094a1.092 1.092 0 0 1-1.093-1.094v-1.094H22.3a1.092 1.092 0 0 1-1.094-1.093c0-.606.489-1.094 1.094-1.094h2.15c.635 0 1.131-.474 1.131-1.072 0-.642-.496-1.116-1.13-1.116h-.649c-1.83 0-3.325-1.465-3.325-3.274 0-1.422.919-2.632 2.188-3.091v-1.291a1.092 1.092 0 1 1 2.188 0v1.094h1.093a1.092 1.092 0 1 1 0 2.188h-2.144c-.628 0-1.137.495-1.137 1.1 0 .598.51 1.087 1.137 1.087h.648c1.831 0 3.319 1.465 3.319 3.26a3.327 3.327 0 0 1-2.917 3.302Zm5.831-20.687 1.447-7.16A.732.732 0 0 0 31.41 6h-2.18c-.798 0-1.449.663-1.461 1.458C27.755 6.663 27.115 6 26.317 6h-2.188a.732.732 0 0 0-.722.86l1.444 7.16h5.834Zm5.726 13.753-5.724-11.295H17.561l-5.724 11.295c-1.728 4.032-.649 8.342 2.063 11.142A10.076 10.076 0 0 0 21.207 42h5.834c2.937 0 5.483-1.203 7.306-3.084 2.712-2.8 3.791-7.11 2.063-11.142Z",
  clipRule: "evenodd"
}));
export default FundingCoverageIcon;